<template>
    <fragment>
        <div v-for="(v, idx) in ands" class="input-group input-group-sm" :key="idx">
            <div class="input-group-prepend">
                <div class="input-group-text pointer" @click="$emit('bdd-and-type-switch', idx)">{{ v.isBut ? 'But' : 'And' }}</div>
            </div>
            <input type="text" class="form-control" :value="v.value" @input="$emit('bdd-and-set-value', {idx, v: $event.target.value})" />
            <div class="input-group-append">
                <div class="input-group-text pointer" @click="$emit('bdd-and-remove', idx)"><fa-icon icon="minus" /></div>
            </div>
        </div>
    </fragment>
</template>

<script>
    export default {
        name: "BddAnd",

        props: {
            ands: {type: Array, default: () => []}
        }
    }
</script>

